import React from 'react'
import { FormattedMessage } from 'react-intl'
import { RoleSwitch } from '../roles'
import { Link } from '@contrast-security-inc/design-system-typography'
import { css } from '@emotion/css'

const linkCss = css`
  font-size: 12px;
`

export const RenderRotateKey = (
  multipleUsersEnabled: boolean,
  onRotateKey: () => void,
  checkRole,
  role,
  fromOrganization?: boolean
) => {
  const showRotate = fromOrganization ? true : !multipleUsersEnabled

  const rotateKey = (
    <div>
      <FormattedMessage id={'action_rotateKeys'}>
        {(text) => (
          <Link className={linkCss} onClick={onRotateKey}>
            {text}
          </Link>
        )}
      </FormattedMessage>
    </div>
  )

  if (!showRotate) {
    return <></>
  }

  if (checkRole && !!role) {
    return (
      <RoleSwitch
        role={role}
        requiredRole="ADMIN"
        renderAllowed={() => rotateKey}
      />
    )
  }

  return rotateKey
}
